import React, { Component } from 'react'

class SimpleRadio extends Component {
    render() {
        const { label, active, option, customOption, subOption, ...rest } = this.props
        return (
            <div className="margin-bottom-20px">
                <div className="txt-site txt-11 txt-bold txt-main display-flex-normal">
                    <h4>{label}</h4>
                </div>
                <div className="margin-15px">
                    <label className="radio">
                        <input
                            {...rest}
                            type="checkbox"
                            checked={active === true ? true : false} />
                        <span className="checkmark" />
                        {customOption ? 
                            <div style={{flexDirection:'column'}}>
                                <span className="txt-site txt-15 txt-bold txt-main" style={{color:'#348cff', fontWeight:'bold'}}>
                                    {option}
                                </span>
                                <br/>
                                <span className="txt-site txt-10 txt-main">
                                    {subOption}
                                </span>
                            </div>:
                            <span className="txt-site txt-11 txt-bold txt-main">
                                {option}
                            </span>
                        }
                    </label>
                </div>
            </div>
        )
    }
}

export default SimpleRadio